namespace $ {
	export class $aspirity_account extends $mol_book2 {
		
		/**
		 * ```tree
		 * domain $aspirity_account_domain
		 * ```
		 */
		@ $mol_mem
		domain() {
			const obj = new this.$.$aspirity_account_domain()
			
			return obj
		}
		
		/**
		 * ```tree
		 * pages /
		 * 	<= Sign_in
		 * 	<= Browse
		 * 	<= New
		 * 	<= Contractor
		 * 	<= Contact
		 * ```
		 */
		pages() {
			return [
				this.Sign_in(),
				this.Browse(),
				this.New(),
				this.Contractor(),
				this.Contact()
			] as readonly any[]
		}
		
		/**
		 * ```tree
		 * Invoice!id $aspirity_account_invoice_page
		 * 	invoice <= invoice!id
		 * 	domain <= domain
		 * ```
		 */
		@ $mol_mem_key
		Invoice(id: any) {
			const obj = new this.$.$aspirity_account_invoice_page()
			
			obj.invoice = () => this.invoice(id)
			obj.domain = () => this.domain()
			
			return obj
		}
		
		/**
		 * ```tree
		 * Placeholder $mol_page
		 * 	Title null
		 * 	Tools null
		 * ```
		 */
		@ $mol_mem
		Placeholder() {
			const obj = new this.$.$mol_page()
			
			obj.Title = () => null as any
			obj.Tools = () => null as any
			
			return obj
		}
		
		/**
		 * ```tree
		 * Sign_in $aspirity_account_sign_in
		 * ```
		 */
		@ $mol_mem
		Sign_in() {
			const obj = new this.$.$aspirity_account_sign_in()
			
			return obj
		}
		
		/**
		 * ```tree
		 * filter_enabled false
		 * ```
		 */
		filter_enabled() {
			return false
		}
		
		/**
		 * ```tree
		 * Browse $aspirity_account_browse
		 * 	domain <= domain
		 * 	filter <= filter_enabled
		 * ```
		 */
		@ $mol_mem
		Browse() {
			const obj = new this.$.$aspirity_account_browse()
			
			obj.domain = () => this.domain()
			obj.filter = () => this.filter_enabled()
			
			return obj
		}
		
		/**
		 * ```tree
		 * New $aspirity_account_new
		 * ```
		 */
		@ $mol_mem
		New() {
			const obj = new this.$.$aspirity_account_new()
			
			return obj
		}
		
		/**
		 * ```tree
		 * Contractor $aspirity_account_contractor
		 * ```
		 */
		@ $mol_mem
		Contractor() {
			const obj = new this.$.$aspirity_account_contractor()
			
			return obj
		}
		
		/**
		 * ```tree
		 * Contact $aspirity_account_contact
		 * ```
		 */
		@ $mol_mem
		Contact() {
			const obj = new this.$.$aspirity_account_contact()
			
			return obj
		}
		
		/**
		 * ```tree
		 * invoice!id $aspirity_account_invoice
		 * ```
		 */
		@ $mol_mem_key
		invoice(id: any) {
			const obj = new this.$.$aspirity_account_invoice()
			
			return obj
		}
	}
	
}

